module.exports = __webpack_public_path__ + "static/media/background-unsplash-karsten-wurth-landscape.0fbb0199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-unsplash-karsten-wurth-landscape.jpg
// module id = 1746
// module chunks = 0